<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-bullhorn"></i></span>{{ 'Announcement.SearchHeader' | translate }}
  </h1>
  <p-card *ngIf="isInDesktopMode()">
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </p-card>

  <ng-content *ngTemplateOutlet="!isInDesktopMode()? content : null"></ng-content>
</div>


<ng-template #content>
  <p-accordion (onOpen)="accordionTabOpen()">
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
      <form [formGroup]="searchForm">
        <div class="p-fluid">
          <div class="field grid">
              <label class="col-12 mb-2 md:col-1 md:mb-0">{{ 'Announcement.HeaderForm.AnnouncementTitle' | translate}}</label>
            <div class="col-12 md:col-8">
              <input pInputText formControlName="announcementTitle" type="text">
            </div>
          </div>
          <div class="field grid">
            <label class="col-12 mb-2 md:col-1 md:mb-0">{{ 'Announcement.HeaderForm.CreateBy' | translate}}</label>
              <div class="col-12 md:col-4">
                <input pInputText formControlName="createUser" type="text">
              </div>
          </div>
          <div class="field grid">
            <label class="col-12 mb-2 md:col-1 md:mb-0">{{ 'Announcement.HeaderForm.AnnouncementDt' | translate}}</label>
            <div class="col-12 md:col-4 laas-calendar">
              <laas-calendar
                #announcementDt
                [defaultDate]="defaultAnnouncementDt"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'announcementDt')">
              </laas-calendar>
            </div>
          </div>
          <div class="field grid">
            <label class="col-12 mb-2 md:col-1 md:mb-0">{{ 'Announcement.HeaderForm.AnnouncementType' | translate}}</label>
            <div class="col-12 md:col-3">
              <p-dropdown formControlName="announcementType"
                [options]="announcementTypeOptions" [showClear]="true" [filter]="true"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}" appendTo="body">
              </p-dropdown>
            </div>
          </div>
        </div>
        <div class="grid align-items-center vertical-container mt-4">
          <button pButton pRipple label="{{ 'Common.Button.Search' | translate}}" (click)="searchBtnClick()" class="ml-2"></button>
          <button pButton label="{{ 'Common.Button.Reset' | translate}}" class="p-button-secondary ml-2" (click)="resetBtnClick()"></button>
          <div *ngIf="this.isAdmin">
            <button pButton label="{{ 'Announcement.Button.NewAnnouncement' | translate}}" class="p-button-success ml-2" (click)="addBtnClick()" [disabled]="!this.isAdmin"></button>
          </div>
      </div>
      </form>
    </p-accordionTab>
  </p-accordion>

  <p-table
    #ViewTable
    laasDataTableSetting
    [tableKey]="preferenceKey"
    [defaultColumns]="tableColumns"
    (setPageSize)="setPageSize($event)"
    [value]="tableValue"
    [scrollable]="true"
    scrollHeight="500px"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    [totalRecords]="pageInfo.totalRecords"
    [tailHeaderDefaultWidths]="isAdmin? [150]: []"
    (onPage)="tablePageChange($event)"
    (onSort)="tableSort($event)"
    [rowsPerPageOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    [paginator]="true"
    [(first)]="first"
    [rows]="5"
    [loading]="isLoading"
    [lazy]="true"
    dataKey="seqNo"
    currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
    selectionMode="single"
    dataKey="seqNo"
    editMode="row"
    class="edittable"
    [(first)]="first"
    styleClass=" mt-2 p-datatable-gridlines p-datatable-striped mt-2 white-space: nowrap;">

    <ng-template pTemplate="caption">
      <laas-table-column-toggle
        [optionsColumn]="tableColumns"
        [dataTable]="ViewTable">
      </laas-table-column-toggle>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        <col *ngIf="isAdmin" style="width: 8vw" />
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          [pSortableColumn]="col.field"
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
          [attr.field]="col.field">
          {{ col.header | translate}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
        <th *ngIf="isAdmin">
          {{ 'Announcement.Table.Action' | translate}}
        </th>
      </tr>
    </ng-template>

    <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-rowIndex="rowIndex"
    >
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowClick(rowData)"
      [ngClass]="{
        'row-yellow': rowData.importantFlag === 'Y'
      }"
      >

        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'announcementTitle'">
              <div class="overflow-text announcement-link">
                <a href="javascript:void(0);" (click)="turnToViewAnnouncement(rowData.seqNo)">{{ rowData[col.field] | replaceNullWith: "-" }}</a>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'status'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: announcementStatusOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'announcementType'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: announcementTypeOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'facility'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: facilityOptions | replaceNullWith: "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd" | replaceNullWith:'-'}}</div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
        <td *ngIf="rowData && isAdmin">
          <p-dropdown #ActionDropDown placeholder="{{ 'Common.DropDown.Select' | translate }}" [showClear]="true" (onChange)="changeActionDropDownList($event)" (onHide)="cleanActionList($event, ActionDropDown)"
                  [options]="actionDropDownList" appendTo="body"
                  class="p-fluid">
          </p-dropdown>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1">
          {{ "Common.Table.NoData" | translate }}
        </td>
      </tr>
    </ng-template>
    </p-table>
</ng-template>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
